// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-bg-waiting[data-v-148b3ba7]{background-color:#f6f78b;color:rgba(47,47,47,.871);height:40px}.label-bg-payment[data-v-148b3ba7]{background-color:#ff964a}.label-bg-payment[data-v-148b3ba7],.label-bg-success[data-v-148b3ba7]{color:hsla(0,0%,100%,.871);height:40px}.label-bg-success[data-v-148b3ba7]{background-color:#7fbb55}.margin-top-twenty[data-v-148b3ba7]{padding-top:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
